import React, { useEffect, useState } from 'react';
import { getPrivacyApi } from '../redux/Reducers/commonApis';
import { dateFn } from '../utils/dateTimeFormatter';
import Loader from '../components/Loader';
export default function Privacy() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const getPrivacyFn = (id) => {
    setLoading(true);
    const response = getPrivacyApi();
    response.then((res) => {
      if (res?.status === 200 || res?.status === 201) {
        setData(res?.data);
        setLoading(false);
      } else {
        setLoading(false);
        toast.error(res?.message || 'Something went wrong');
      }
    });
  };
  useEffect(() => {
    getPrivacyFn();
  }, []);

  return (
    <div className='sm:max-w-9xl w-full p-4 sm:mx-auto sm:p-6'>
      {loading ? (
        <Loader text='loading privacy...' classes='h-96' />
      ) : (
        <div className=''>
          <p className='go-textblacknormal-16'>Last modified {dateFn('MM/DD/YYYY', data?.privacy_modified_date)}</p>
          <div className='go-textblacknormal-15 rounded-lg bg-white p-5 '>
            <p className='mb-5'>{data?.privacy}</p>
          </div>
        </div>
      )}
    </div>
  );
}
